import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { subtitles } from '../../data/om-mig-data';
export function OmMigHero() {
  const [subtitleIndex, setSubtitleIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setSubtitleIndex(prev => (prev + 1) % subtitles.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <section className="py-20 md:py-28 px-6 bg-background" data-id="element-107">
      <div className="max-w-4xl mx-auto text-center" data-id="element-108">
        <motion.span className="text-terracotta font-medium tracking-widest text-xs uppercase mb-4 block" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-109">
          Peter Alkeryd
        </motion.span>

        <h1 className="text-4xl md:text-6xl font-light text-ink leading-[1.1] mb-6 h-20 md:h-24" data-id="element-110">
          Affärsrådgivare.{' '}
          <AnimatePresence mode="wait" data-id="element-111">
            <motion.span key={subtitleIndex} className="text-terracotta inline-block" initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -10
          }} transition={{
            duration: 0.3
          }} data-id="element-112">
              {subtitles[subtitleIndex]}
            </motion.span>
          </AnimatePresence>
        </h1>

        <motion.p className="text-xl text-muted font-light max-w-2xl mx-auto leading-relaxed mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-113">
          Kombinerar affärsanalys, ekonomisk förståelse och praktiskt
          genomförande.
        </motion.p>

        {/* Profile Photo */}
        <motion.div className="relative w-full max-w-2xl mx-auto aspect-[4/3] rounded-2xl overflow-hidden shadow-xl border border-border/50" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-114">
          <img src="https://cdn.magicpatterns.com/uploads/rp124j7TwQNKm6HBwYEcjY/BE93E70C-A773-466A-A763-08D13C4C421B_1_105_c.jpg" alt="Peter Alkeryd" className="w-full h-full object-cover object-top" data-id="element-115" />
          <div className="absolute top-4 left-4 bg-white/10 backdrop-blur-md px-3 py-1 rounded-full border border-white/10" data-id="element-116">
            <span className="text-white text-xs font-medium" data-id="element-117">Om Peter</span>
          </div>
        </motion.div>
      </div>
    </section>;
}